import makeCrud from '@/store/site/localization/crud'

export default makeCrud('manager_site')
